import { Pipe, PipeTransform } from '@angular/core';
import {
  currencyPlaceholderVariable,
  pricePlaceholderVariable,
} from '../components/marketing-email-collector/marketing-email-collector-placeholder-variables';

@Pipe({
  name: 'replacePriceAndCurrency',
})
export class ReplacePriceAndCurrencyPipe implements PipeTransform {
  public transform(value: string, price: number, currency: string): string {
    return value.replace(pricePlaceholderVariable, price?.toString()).replace(currencyPlaceholderVariable, currency);
  }
}
